import { render, staticRenderFns } from "./CarCategory.vue?vue&type=template&id=1fc3d216&scoped=true"
import script from "./CarCategory.vue?vue&type=script&lang=js"
export * from "./CarCategory.vue?vue&type=script&lang=js"
import style0 from "./CarCategory.vue?vue&type=style&index=0&id=1fc3d216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3d216",
  null
  
)

export default component.exports